<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'selectionInfo-masterdata-page',
};
</script>

<style>

</style>
